import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import RelatedLinks from '../RelatedLinks';
import MoneyZakatTable from './MoneyZakatTable';
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Money_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = `Calcul de Zakat sur l'argent 2026 - Calculatrice du seuil de Zakat sur l'argent`;
const DESCRIPTION =
  "Calcul de Zakat sur l pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "calcul de zakat sur l, calculatrice calcul de zakat sur l, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = 'https://do-calculate.com/calculator/fr/money-zakat/';
const apiEndpoint = `${SERVER_URL}/${Money_Zakat_EndPoint}`;
function MoneyZakatCalculator() {
    const [amount, setAmount] = useState('');
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [thresholdType, setThresholdType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const handleThresholdTypeChange = (event) => {
        const newThresholdType = event.target.value;
        setThresholdType(newThresholdType);
        if (newThresholdType === "gold") {
            setGramPriceSilver(0);
        } else if (newThresholdType === "silver") {
            setGramPriceGold(0);
        }
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateMoneyZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ amount, yearType, gramPriceGold, gramPriceSilver }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="ltr">
            <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Calculez la zakat sur l'argent</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                La calculatrice zakat argent est un outil utilisée pour calculer le montant de la zakat due sur les fonds en espèces, les économies et les investissements et calculer le seuil de zakat sur l'argent et le montant de la zakat à payer. La calculatrice est conçue pour tenir compte de la valeur de l'argent possédé, du type d'année civile (hijri ou grégorienne) et des prix de l'or et de l'argent pour calculer le montant minimum d'argent soumis à la zakat.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Calculatrice Zakat sur l'argent</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Type d'année</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="gregorianRadio"
                                            name="yearType"
                                            value="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorianRadio">
                                            Grégorienne
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="hijri"
                                            name="yearType"
                                            value="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijri
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="amoutNumber" className="form-label ms-2" >Montant total</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="amoutNumber"
                                        value={amount}
                                        onChange={handleAmountChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Type de seuil</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="gold"
                                            name="thresholdType"
                                            value="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            Or
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="silver"
                                            name="thresholdType"
                                            value="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            Argent
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceSilver == 0}
                                        <b>
                                            <label className="form-label ms-2">Prix par gramme d'or (24 carats)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceGold == 0}
                                        <b>
                                            <label className="form-label ms-2">Prix par gramme d'argent (99.9 carats)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                <br/>
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateMoneyZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Chargement...</span>
                                        </div>
                                    ) : (
                                        'Calculer'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Erreur :</u></b> Veuillez remplir tous les champs correctement. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Résultats: </div></h4>
                                            <hr />
                                            <MoneyZakatTable result={result}></MoneyZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description de la calculatrice Zakat sur l'argent</div>
                            <div className="info-section-body">
                                <div>
                                    <h2 style={{ fontSize: '15px' }}>Seuil de Zakat sur l'argent - Montant de Zakat obligatoire</h2>
                                    <p>
                                        La calculatrice zakat argent est basée sur le calcul du seuil de zakat selon les normes religieuses islamiques. Par exemple, dans la zakat hijri, le seuil doit être un montant équivalant à 85 grammes d'or, et dans la zakat grégorienne, le seuil est un montant équivalant à 595 grammes d'argent. Si la valeur de l'argent que vous possédez dépasse ce seuil, vous devez payer la zakat.
                                    </p>
                                    <br />
                                    <h2 style={{ fontSize: '15px' }}>Comment calculer la Zakat sur l'argent</h2>
                                    <p>
                                        La calculatrice calcule le montant de la zakat due en fonction des valeurs entrées par l'utilisateur, selon les dispositions de la loi islamique. Si la valeur de l'argent dépasse le seuil défini selon l'année civile et les prix de l'or ou de l'argent, la calculatrice calcule le taux de zakat prescrit, qui est de 2,5% pour la zakat hijri et de 2,577% pour la zakat grégorienne. Ensuite, elle détermine l'état de la zakat si elle est due ("oui") et calcule le montant financier à payer.
                                    </p>
                                    <p>
                                        La calculatrice présente ses résultats sous la forme d'un rapport qui comprend l'état de la zakat ("oui" ou "non"), le montant due, et la valeur minimale de l'argent pour lequel la zakat est obligatoire.
                                    </p>
                                    <br />
                                    <hr />
                                    <b>Dernière révision : </b>
                                    28/02/2026
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MoneyZakatCalculator;
